import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-refund-request-success',
  templateUrl: './refund-request-success.component.html',
  styleUrls: ['./refund-request-success.component.css']
})
export class RefundRequestSuccessComponent implements OnInit {
  transID: any;
  constructor(public dialogRef: MatDialogRef<RefundRequestSuccessComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public commonService : CommonService,
    public router : Router) { }

  ngOnInit(): void {
  }
  
  onNoClick(): void {
    this.dialogRef.close();
    this.commonService.triggerGridRefresh();
    //this.router.navigate(['/All/refunds']);
  }
}
